import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { ItemMinimalDetails } from "../models/cart-data.model";
import { AppConfigService } from "./app-config.service";
import { ApiService } from "./api.service";
import { catchError } from "rxjs/operators";

@Injectable({
    providedIn: "root"
})
export class ProductService {
    private _vistekUrl: string;

    constructor(
        private _httpClient: HttpClient,
        private _appConfigService: AppConfigService,
        private _apiService: ApiService
    ) {
        this._vistekUrl = this._appConfigService.vistekUrl;
    }

    public getProductMinimalDetails(webCodes: string[]): Observable<ItemMinimalDetails[]> {
        let targetUrl = `${this._vistekUrl}/products/minimal`;

        return this._httpClient.post<ItemMinimalDetails[]>(targetUrl, webCodes, {
            headers: this._apiService.xsrfHeader
        });
    }

    public getFrequentlyBoughtTogetherProducts(webCode: string, includeSelfInResult: boolean): Observable<ItemMinimalDetails[]> {
        let targetUrl = `${this._vistekUrl}/products/frequentlyboughttogether`;
        const payload = {
            webCode,
            includeSelfInResult
        };

        return this._httpClient.post<ItemMinimalDetails[]>(targetUrl, payload, {
            headers: this._apiService.xsrfHeader
        }).pipe(catchError(() => []));
    }

    public getRelatedProducts(webCode: string): Observable<ItemMinimalDetails[]> {
        let targetUrl = `${this._vistekUrl}/products/related`;
        const payload = {
            webCode
        };

        return this._httpClient.post<ItemMinimalDetails[]>(targetUrl, payload, {
            headers: this._apiService.xsrfHeader
        }).pipe(catchError(() => []));
    }

    public getTrendingProducts(facetName: string, facetValue: string): Observable<ItemMinimalDetails[]> {
        let targetUrl = `${this._vistekUrl}/products/trending`;
        const payload = {
            facetName,
            facetValue
        };

        return this._httpClient.post<ItemMinimalDetails[]>(targetUrl, payload, {
            headers: this._apiService.xsrfHeader
        }).pipe(catchError(() => []));
    }
}
